import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { LiveDataContext } from 'context/liveData';
import { Unauthorized } from 'components';

import Auth from 'auth0-react';

const AuthRoute = ({ component, ...args }: any) => {
  const { isAuthenticated } = new Auth();
  const { isUnauthorized } = LiveDataContext();

  /**
   * User authenticated then,
   * - if on login route redirect to the insights route by default.
   * - else allow routing to the desired route.
   */
  if (isAuthenticated()) {
    if (args.path === '/login') return <Redirect to="/" />;
    if (isUnauthorized) return <Unauthorized />;
    return <Route {...args} component={component} />;
  }

  /**
   * If not authenticated, then allow setting login component route, then route to login compo, else always redirect to /login.
   */
  if (args.path === '/login') return <Route {...args} component={component} />;

  return <Redirect to="/login" />;
};

export default AuthRoute;
